<template>
  <div>
     <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

        <a-card class="all-card-style " >

   <!--      搜索模块-->
      <div class="search-box">
        <a-form layout="inline">

          <a-form-item
            label="内容" class="ant-form-item2"
          >
            <a-input
              placeholder="请输入" v-model="paramas.keyword"
            >
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
           <a-form-item
            label="开始时间" class="ant-form-item2"
          >
             <a-date-picker v-model="paramas.dStartDate" placeholder="请选择开始时间" />
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
          </a-form-item>
           <a-form-item
            label="结束时间" class="ant-form-item2"
          >
             <a-date-picker v-model="paramas.dEndDate" placeholder="请选择结束时间" />
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />

          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" @click="handlePageList"  >
              查询
            </a-button>
          </a-form-item>

        </a-form>
      </div>
      <!-- 搜索 -->

       <!--      列表表格-->

            <div style="margin-top:20px;">
               <a-button type="primary" html-type="submit" @click="toAddPage">
              +新建
            </a-button>
              <a-table   id="printTest" @change="handleTableChange" :pagination="pagination" :columns="columns"
                         :data-source="data" :row-selection="rowSelection"  style="margin-top:20px;">
                <template slot="Title" slot-scope="text,record">
              <span v-html="record.cPic">
                   </span>
                </template>
                <span slot="action" slot-scope="text, record">
           <div>
                  <a @click="showDeleteModal(record)">删除</a>
    <a-divider type="vertical"/>
               <a @click="toEditPage(record)">修改</a>
           </div>
          </span>


              </a-table>
            </div>
      <!-- 列表 -->
        </a-card>

    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleDelete" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal>

  </div>
</template>


<script>
  import TitleCard from '@/components/TitleCard.vue'

  // 表格前选择
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    onSelect: (record, selected, selectedRows) => {
      console.log(record, selected, selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
    },
  };
  export default {
    name: 'logList',
    components: {
      TitleCard
    },
    data(){
      return{
        titleMsg1:"精准灌溉",
        titleMsg2:'灌水计划',
        titleMsg3:'灌水计划',
        data:[

        ],
        columns,
        paramas:{
          keyword:"",
          sceneId:"",
          cEntID:"",
          page:1,
          limit:10,
          dStartDate:'',
          dEndDate:''
        },
        rowSelection,
        deleteModalVisible:false,
        pagination: {
          current:1,
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
        },

        record:{},
      }
    },

    mounted () {
      let that=this;
      that.paramas.sceneId=that.$store.getters.SCene.ID;
      that.paramas.cEntID=that.$store.getters.User.enterprise.ID;

      that.$bus.$on('scenechange',(target)=> {
        that.paramas.sceneId=target.id;
        that.handlePageList();
      });
      that.handlePageList();
    },
    methods:{
      print(){
        this.$print(this.$refs.prints)
      },
      export2Excel(){

        let that=this;

        require.ensure([], () => {
          const { export_json_to_excel } = require('vendor/Export2Excel');
          //头
          const tHeader = [ '灌水计划组', '灌水计划编号', '灌水名称','作物','作物生长期', '灌溉面积','灌水次数','灌水定额', '灌水开始时间','灌水结束时间'];
          //对应的标签
          const filterVal = ['cGroupNum', 'cPlanNum', 'cTitle','cCropName','CropGrowthPeriodName','fArea', 'iNum' ,'fQuota', 'dStartDate','dEndDate'];
          //标签对应的内容  是一个数组结构
          const list = that.data;
          //一个方法 我也不知道干嘛的
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, '投喂excel');
        })
      },
      formatJson(filterVal, jsonData){
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      handleTableChange(pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.paramas.page = pagination.current;
        this.paramas.limit = pagination.pageSize;
        this.handlePageList();
      },
      async handlePageList(){
        let that=this;

        let res= await that.$http.post('EntWLWCropIrrigationPlan/PageList',that.paramas)

        if(res.data.code=="200"){

          that.data= res.data.obj.list;

        }
        else{
          that.$message.error(res.message)

        }
      },
      //删除
      async handleDelete(){
        let that=this;
        let param={ids:that.record.ID};
        let res=await that.$http.post('EntWLWCropIrrigationPlan/sDel?ids='+that.record.ID,param)


        if(res.data.code=="200"){
          this.deleteModalVisible=false;
          that.$message.success(res.data.message)
          that.handlePageList();
        }
        else{
          that.$message.error(res.message)

        }
      },
      showDeleteModal:function (obj) {
        this.record=obj;
        this.deleteModalVisible=true;
      },
      toEditPage(obj){
        let that=this;
        this.$router.push({name:'precisionIrrigationNewAdd',params:{ID:obj.ID,sceneId:that.paramas.sceneId}});
      },
      toDistPage(obj){
        let that=this;
        this.$router.push({name:'WorkOrderManagementDist',params:{ID:obj.ID,sceneId:that.paramas.sceneId}});
      },
      toAddPage(){
        this.$router.push({path:'/precisionIrrigation/IrrigationPlan/precisionIrrigation'})

      },

    }
  }
  const columns = [

    {
      title: '灌水计划组',
      dataIndex: 'cGroupNum',
      key: 'cGroupNum',
      className:'column-money'
    },
    {
      title: '灌水计划编号',
      dataIndex: 'cPlanNum',
      key: 'cPlanNum',
      className:'column-money'
    },
    {
      title: '灌水名称',
      dataIndex: 'cTitle',
      key: 'cTitle',
      className:'column-money'
    },
    {
      title: '作物',
      dataIndex: 'cCropName',
      key: 'cCropName  ',
      className:'column-money'
    },
    {
      title: '作物生长期',
      dataIndex: 'CropGrowthPeriodName',
      key: 'CropGrowthPeriodName',
      className:'column-money'
    },
    {
      title: '灌溉面积',
      dataIndex: 'fArea',
      key: 'fArea',
      className:'column-money'

    },
    {
      title: '灌水次数',
      dataIndex: 'iNum',
      key: 'iNum',
      className:'column-money'
    },
    {
      title: '灌水定额',
      dataIndex: 'fQuota',
      key: 'fQuota',
      className:'column-money'
    },
    {
      title: '灌水开始时间',
      dataIndex: 'dStartDate',
      key: 'dStartDate',
      className:'column-money'
    },
    {
      title: '灌水结束时间',
      dataIndex: 'dEndDate',
      key: 'dEndDate',
      className:'column-money'
    },
    {
      title: '操作',
      dataIndex: 'num',
      key: 'num',
      className:'column-money',
      scopedSlots: { customRender: 'action' },
    },
  ];

</script>
